import React from 'react';
import styled from "styled-components";
import Cookies from 'js-cookie';

import MainNav from '../components/minskog/comps/MainNav';
import Karta from '../components/minskog/Karta';
import DroneAnalysis from '../components/minskog/comps/DroneAnalysis/DroneLandingPage';
import Overblick from '../components/minskog/Overblick';
import ProfileAdListings from '../components/minskog/ProfileAdListings';

//import { checkPropStatus, fetchPropData } from '../components/minskog/helpers';
import { usePropertyFetcher } from '../components/minskog/hooks/usePropertyFetcher';
import Aragon from '../components/minskog/Aragon';
import { DroneProvider } from "../components/minskog/context/DroneContext";
import * as DroneSteps from "../components/minskog/comps/DroneCheckout/steps";
import DroneCheckout from '../components/minskog/comps/DroneCheckout/DroneCheckout';
import { SubscriptionCheckoutContext } from '../components/minskog/context/SubscriptionCheckoutContext';
import SubscriptionCheckout from '../components/minskog/comps/SubscriptionCheckout';
import { useDFR, DFRProvider } from "../components/minskog/context/DFRContext";
import ArbonicsDialog from '../components/minskog/comps/ArbonicsDialog/ArbonicsDialog';
import DFRCheckoutDialog from '../components/minskog/comps/DFRCheckoutDialog/DFRCheckoutDialog';
import { PropsData, Navigation, VisaValda, UserData } from '../components/minskog/context';

import { fetchUserAdData } from '../api/services/user';

import Spinner from 'react-bootstrap/Spinner';
import PricingPage from '../components/minskog/aragon/PricingPage';

import { TailwindWrapper } from "../components/TailwindWrapper/TailwindWrapper";
import { Dialog, Text, Button,Icon } from "@virkesborsen/ui-component-library";

const ContentView = styled.div`
    width: 100%;
    height: calc(100dvh - 80px);

    @media (min-width:992px) {
        width: calc(100% - 322px);
        height: 100%;
    }
`

function MinSkogContent() {
    const kartaRef = React.useRef();
    const aragonRef = React.useRef();

    const viewOptions = ['karta', 'overblick', 'overvakning', 'annonser', "drone", 'pricing']
    
    const urlSearchParams = new URLSearchParams(window.location.search);
    const [props, setProps] = React.useState(Window.react_data.owned_props);
    const [view, setView] = React.useState(urlSearchParams.get('view') && viewOptions.includes(urlSearchParams.get('view')) ? {comp: urlSearchParams.get('view')} : history.state && history.state != null ? history.state : {comp: 'overblick'});
    const [visaValda, setVisaValda] = React.useState(false);
    const [userData, setUserData] = React.useState(null);
    const [couponCode, setCouponCode] = React.useState(null);
    const [dfrCheckoutStep, setDfrCheckoutStep] = React.useState(undefined);
    const [arbonicsDialogVisible, setArbonicsDialogVisible] = React.useState(false);
    const [isReady, setIsReady] = React.useState(false)
    const [dec2025Popup, setDec2025Popup] = React.useState(false);
    
    // Drone checkout
    const [droneInitialStep, setDroneInitialStep] = React.useState(1);
    const [isDroneDialogOpen, setIsDroneDialogOpen] = React.useState(false);

    // Subscription checkout
    const [isSubscriptionDialogOpen, setIsSubscriptionDialogOpen] = React.useState(false);
    const [subscriptionInitialStep, setSubscriptionInitialStep] = React.useState(1);

    const DFRContext = useDFR();
    const numberOfDroneSteps = Object.keys(DroneSteps).length;
    const { fetchPropData, checkPropStatus } = usePropertyFetcher();

    React.useEffect(async () => {
        window.addEventListener('popstate', () => handleHistory());

        if(Window.react_data.popup_dec_2025) {
            setDec2025Popup(true)
        }

        const clearParam=(param,state=null)=>{
            const url = new URL(window.location.href);
            url.searchParams.delete(param);
            history.replaceState(state, '', url.toString());
        }

        let propsToActivate = []

        // Handle URL parameters
        if(urlSearchParams) {
            
            if(urlSearchParams.get("dfr-coupon")) {         
                const couponCode = urlSearchParams.get("dfr-coupon")
                setCouponCode(couponCode);
                DFRContext.showCheckout(true)
                clearParam('dfr-coupon')
            }

            if(urlSearchParams.get("dfr-thank-you")) {         
                setDfrCheckoutStep(2);
                DFRContext.showCheckout(true)
                clearParam('dfr-thank-you')
            }

            if(urlSearchParams.get("drone")) {         
                setDroneInitialStep(1);
                setIsDroneDialogOpen(true);
                clearParam('drone')
            }

            if(urlSearchParams.get("copture-thank-you")) {
                setDroneInitialStep(4);
                setIsDroneDialogOpen(true);
                clearParam('copture-thank-you')
            }

            if(urlSearchParams.get("subscription-checkout")) {         
                setSubscriptionInitialStep(1);
                setIsSubscriptionDialogOpen(true);
                clearParam('subscription-checkout')
            }

            if(urlSearchParams.get("subscription-thank-you")) {
                setSubscriptionInitialStep(3);
                setIsSubscriptionDialogOpen(true);
                clearParam('subscription-thank-you')
            }

            if(urlSearchParams.get('view')) {
                const view = viewOptions.includes(urlSearchParams.get('view')) ? {comp: urlSearchParams.get('view')} : {comp: 'karta'}
                clearParam('view',view)
            }

            if(urlSearchParams.get('carbon-credit-flow')){
                setArbonicsDialogVisible(true)
                clearParam('carbon-credit-flow')
            }

            if(urlSearchParams.get("ref")) {
                propsToActivate.push(urlSearchParams.get("ref"))
                const url = new URL(window.location.href);
                url.searchParams.delete('ref');
                history.replaceState(null, '', url.toString());
            }
        }

        let CookieProps = Cookies.get('activeProps')
        if(CookieProps && CookieProps != '' && propsToActivate.length < 1) {
            CookieProps.split(',').map(c => propsToActivate.push(c))
        }

        // List of properties there is data for and we want to fetch
        const propsToFetch = props.filter(p => p.status === 'data' && !p.data)

        // Set the properties to active that user was watching last time to load them first.
        await propsToFetch.map(p => {
            const preSelected = propsToActivate.includes(p.ref.toString())
            p.checked = preSelected
            p.active = preSelected
        })
        // When data finishes loading set isReady to true
        setIsReady(true)

        setTimeout(async () => {
            if(propsToFetch.length > 10) {
                await Promise.all(
                    propsToFetch.filter(p => p.active).map(async p => {
                        try {
                            await fetchPropData(setOneProp, p)
                        } catch(error) {
                            console.error(`Error fetching data for ${p.designation}:`, error)
                        }
                    })
                )
            } else {
                await Promise.all(
                    propsToFetch.map(async p => {
                        try {
                            await fetchPropData(setOneProp, p)
                        } catch(error) {
                            console.error(`Error fetching data for ${p.designation}:`, error)
                        }
                    })
                )
            }
        }, 200)

        // Poperties that are still being generated, keep checking for their status
        props.filter(p => p.status == 'running').map(async p => checkPropStatus(setOneProp, p))
        
        const userAdDataResp = await fetchUserAdData()
        if(userAdDataResp.ok) {
            setUserData(userAdDataResp.data)
        } else {
            setUserData(false)
        }

        return () => {
            window.removeEventListener('popstate', () => handleHistory());
        };
    }, [])

    const handleHistory = () => {
        setView(history.state ? history.state : {comp: 'overblick'})

        if(history.state) {
            if(history.state.active) {
                const newActiveProps = props.map(p => history.state.active.includes(p.ref) ? {...p, active: true} : {...p, active: false})
                setProps(newActiveProps)
                setVisaValda(true)
            }
    
            if(history.state.comp == 'karta') {
                kartaRef.current.handleHistory(history.state.section)
            }

            if(history.state.comp == 'overvakning') {
                aragonRef.current.handleHistory()
            }
        }
    }

    const setOneProp = (p) => {
        if(props.find(prop => prop.ref == p.ref)) {
            let newList = props.map(prop => prop.ref === p.ref ? p : prop)
            setProps(newList)
        } else {
            props.push(p)
            setProps(props)
        }
    }

    const tempProfileAdListingsLoading = () => {
        return <div className='container'>
            <div className='d-flex flex-column vh-100 justify-content-center align-items-center'>
                <Spinner animation="border" size="xl" />
                <p className='mt-3'>Vi laddar in din data...</p>
            </div>
            
        </div>
    }

    return (
        <PropsData.Provider value={{props, setProps, setOneProp}}>
        <SubscriptionCheckoutContext isOpen={isSubscriptionDialogOpen}  initialStep={subscriptionInitialStep}>
        <DroneProvider isOpen={isDroneDialogOpen} totalSteps={numberOfDroneSteps} initialStep={droneInitialStep}>
        <Navigation.Provider value={{view, setView}}>
        <VisaValda.Provider value={{visaValda, setVisaValda}}>
        <UserData.Provider value={{userData, setUserData}}>
            <div className='container-fluid vh-100'>
                <div className='row h-100'>
                    <MainNav />
                    <ContentView id='mainContainer' className='col-12 position-relative overflow-auto p-0'>                        
                        {view?.comp == 'karta' && isReady && <Karta ref={kartaRef} />}
                        {view?.comp == 'overblick' && isReady && <Overblick />}
                        {view?.comp == 'overvakning' && isReady && <Aragon ref={aragonRef} />}
                        {view?.comp == 'pricing' && isReady && <PricingPage />}
                        {view?.comp == 'annonser' && (userData ? <ProfileAdListings data={userData} /> : tempProfileAdListingsLoading())}
                        {view?.comp == 'drone' && <DroneAnalysis />}
                    </ContentView>
                </div>
            </div>

            <TailwindWrapper>
                <Dialog isOpen={dec2025Popup}>
                    <Dialog.Header className="justify-between items-center">
                        <Text variant="text-lg/leading-normal/medium">
                            Välkommen till Treebula Bas
                        </Text>
                    </Dialog.Header>
                    <Dialog.Content>
                        <Text variant="text-base/leading-normal/normal" className='mb-4'>
                            Vi har gjort Treebula ännu enklare och mer användbart för dig i din vardag som skogsägare. Vår paketering är nu tydligare, så att du snabbt hittar det du behöver.
                        </Text>

                        <Text variant="text-base/leading-normal/normal">
                            Som befintlig gratisanvändare har du kvar tillgång till de verktyg du är van vid:
                        </Text>
                        <ul className='list-disc list-inside mb-4'>
                            <Text as='li' variant="text-base/leading-normal/normal">Delar av din skogsbruksplan och all vår marknadsinformation.</Text>
                            <Text as='li' variant="text-base/leading-normal/normal">Vår prisjämförelse – för transparens i affären.</Text>
                            <Text as='li' variant="text-base/leading-normal/normal">Möjligheten att sälja virke och biobränsle.</Text>
                            <Text as='li' variant="text-base/leading-normal/normal">Funktionen för att utforska kolkrediter och skogens fulla potential.</Text>
                        </ul>
                            
                        <Text variant="text-base/leading-normal/normal" className='mb-4'>
                            Är du redo att ta full kontroll över din skogsfastighet? Treebula Plus ger dig komplett skogsbruksplan, skogsövervakning och mycket mer.
                        </Text>

                        <Text variant="text-base/leading-normal/normal" className='mb-4'>
                            Vänliga hälsningar,
                        </Text>

                        <Text variant="text-base/leading-normal/normal">
                            Treebula-teamet
                        </Text>
                    </Dialog.Content>
                    <Dialog.Footer>
                        <div className='flex justify-between'>
                            <Button tw variant="secondary" onClick={() => setDec2025Popup(false)}>Stäng</Button>
                            <Button tw variant="primary" onClick={() => { window.location.href = "/min-skog/?view=pricing"; setDec2025Popup(false) }}><React.Fragment key=".0">
                                Läs mer om Plus
                                <Icon
                                    color={"white-500"}
                                    name="ArrowRightSimple"
                                />
                            </React.Fragment></Button>
                        </div>
                    </Dialog.Footer>
                </Dialog>
            </TailwindWrapper>
            
            <SubscriptionCheckout/>
            <DroneCheckout/>
            <ArbonicsDialog visible={arbonicsDialogVisible} hide={()=>{setArbonicsDialogVisible(false)}}/>
            <DFRCheckoutDialog visible={DFRContext.checkout} hide={() => DFRContext.showCheckout(false)} initialStep={dfrCheckoutStep} couponCode={couponCode}  setCouponCode={setCouponCode} />
        </UserData.Provider>
        </VisaValda.Provider>
        </Navigation.Provider>
        </DroneProvider>
        </SubscriptionCheckoutContext>
        </PropsData.Provider>
    );
}

export default function MinSkog() {
    return (
        <DFRProvider>
            <MinSkogContent />
        </DFRProvider>
    );
}